import { useState } from "react";
import { showToast } from "./ToastNotification";

const ModalEditTeam = ({ team, token, onClose, onUpdated }) => {
  const [form, setForm] = useState({
    team_name: team.team_name,
    phone: team.phone,
    city: team.city,
    facebook: team.facebook || "",
    instagram: team.instagram || "",
    tiktok: team.tiktok || "",
  });

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSave = async () => {
    try {
      const res = await fetch(
        `https://server-postgre.vercel.app/api/teams/${team.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(form),
        },
      );

      const data = await res.json();
      if (!res.ok) throw new Error(data.message);

      showToast.success("Información actualizada correctamente");

      if (onUpdated) onUpdated(data);

      onClose();
    } catch (error) {
      console.error(error);
      showToast.error("Error al actualizar información");
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 w-full max-w-lg shadow space-y-4">
        <h2 className="text-xl font-semibold">Editar Información del Equipo</h2>

        <div className="space-y-3">
          {Object.entries(form).map(([key, value]) => (
            <input
              key={key}
              type="text"
              value={value}
              placeholder={key}
              onChange={(e) => handleChange(key, e.target.value)}
              className="w-full border rounded-lg p-2"
            />
          ))}
        </div>

        <div className="flex justify-end gap-3 pt-4">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm border rounded-lg"
          >
            Cancelar
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 text-sm bg-green-600 text-white rounded-lg shadow hover:bg-green-700"
          >
            Guardar cambios
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalEditTeam;
